import React, { Component } from "react";
import patientIcon from "../../assets/images/Patient.svg";
import userIcon from "../../assets/images/user_color.svg";
import token from "../../assets/images/TokenGenerator.svg";
import service from "../../assets/images/service.svg";
import * as moment from "moment";
import { ClockCircleOutlined } from '@ant-design/icons';

class TokenPatientCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderTime(date) {
    return moment(date).format("hh:mm A");
  }
  render() {
    const { item } = this.props;
    return (
      <div className="py-1 pl-4 pr-1 mr-1 mt-2 b-card-body disable-text">
        {/* Patientname */}
        {/* <div className="row">
          <img alt="" src={patientIcon} className="patientIcon ml-0 mr-1" />
          <span className="Patientname">
            {item.patient_name ? item.patient_name : "--"}
          </span>
        </div> */}
        {/* phone - status */}
        <div className="row mt-1 mb-3 displaySpaceBetween">
          <div>
            <img
              alt=""
              src={userIcon}
              width={20}
              height={20}
              className="uidIcon"
            />
            <span class="PatientUid">
              {item.phone_number ? item.phone_number.slice(0, 2)+'******'+ item.phone_number.slice(8, 10): "--"}
            </span>
          </div>
          <div>
            <span class="tstatus">
              {item.current_workflow_stageid === "1" ? "IN" : "OUT"}
            </span>
          </div>
        </div>
        {/* token no. and time */}
        <div className="row pr-3 mt-1 displaySpaceBetween">
          <div>
            <img
              alt=""
              src={token}
              width={20}
              height={20}
              className="uidIcon"
            />
            <span class="PatientUid">
              {item.token_display_id ? item.token_display_id : "--"}
            </span>
          </div>
          <div className="tPatientname">
            <div>
            {/* <Icon
              type="clock-circle"
              style={{
                color: "#ac7ab0",
                transform: "rotate(0deg)",
                fontSize: "17px",
                margin: "0 5px 0 0",
              }}
            /> */}
          

<ClockCircleOutlined
  style={{
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '17px',
    margin: '0 5px 0 0',
  }}
/>

            </div>
            
            <div className="mt-1">Token Issued:{" "}
            {this.renderTime(item.token_datetime)
              ? this.renderTime(item.token_datetime)
              : "HH:MM"}
              </div>
          </div>
        </div>
      </div>
    );
  }
}
export default TokenPatientCard;
